import { render, staticRenderFns } from "./ButtonSubMerchant.vue?vue&type=template&id=4ea0b329&scoped=true&"
import script from "./ButtonSubMerchant.vue?vue&type=script&lang=js&"
export * from "./ButtonSubMerchant.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSubMerchant.vue?vue&type=style&index=0&id=4ea0b329&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea0b329",
  null
  
)

export default component.exports